import { captureException } from '@sentry/react'

const catchWrapper = (func) => {
  try {
    return func()
  } catch (error) {
    console.error(error)
    captureException(error)
  }
}

export default catchWrapper
